import Spinner from "./UxbiSpinner";
import React, { useState, useEffect, useRef } from "react";
import { Modal, Button, Alert } from "react-bootstrap";
import { Printer, Download } from "lucide-react";
import { requestBlob } from "../api/http";
import { toast } from "react-toastify";
export async function downloadDocument(id, type, { basePath = "comercial-app/documentos", filePrefix = "Documento" } = {}) {
  const blob = await requestBlob(`${basePath}/${id}/${type}`);
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `${filePrefix}-${id}.${type}`;
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
export default function DocumentViewer({ id, onClose, basePath = "comercial-app/documentos", htmlSuffix = "html", title = "Detalles del documento", filePrefix = "Documento" }) {
  const [downloading, setDownloading] = useState(false);
  const [url, setUrl] = useState(""),
    [error, setError] = useState(""),
    [retry, setRetry] = useState(0),
    [ready, setReady] = useState(false);
  const frame = useRef();
  useEffect(() => {
    const c = new AbortController();
    let live = true,
      objectUrl = "";
    setError("");
    setReady(false);
    setUrl("");
    requestBlob(`${basePath}/${id}/${htmlSuffix}`, { signal: c.signal })
      .then((b) => {
        if (!b.type.includes("html"))
          throw new Error("El servidor no devolvió un documento HTML.");
        if (live) {
          objectUrl = URL.createObjectURL(b);
          setUrl(objectUrl);
        }
      })
      .catch((e) => {
        if (live) setError(e.message);
      });
    return () => {
      live = false;
      c.abort();
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [id, retry, basePath, htmlSuffix]);
  return (
    <Modal
      show
      onHide={onClose}
      size="xl"
      fullscreen="md-down"
      className="document-viewer"
    >
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {error ? (
          <Alert variant="danger">
            {error}
            <Button variant="link" onClick={() => setRetry(retry + 1)}>
              Reintentar
            </Button>
          </Alert>
        ) : !url ? (
          <div className="panel-loading">
            <Spinner label="Cargando documento…" />
            <span>Cargando documento…</span>
          </div>
        ) : (
          <iframe
            ref={frame}
            title="Formato del documento"
            src={url}
            sandbox="allow-same-origin allow-modals"
            onLoad={() => setReady(true)}
          />
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="light"
          disabled={downloading}
          onClick={async () => {
            setDownloading(true);
            try { await downloadDocument(id, "pdf", { basePath, filePrefix }); }
            catch(e) { toast.error(e.message); }
            finally { setDownloading(false); }
          }}
        >
          {downloading ? <Spinner size="sm" /> : <Download size={17} />} PDF
        </Button>
        <Button
          disabled={!ready}
          onClick={() => frame.current?.contentWindow?.print()}
        >
          <Printer size={17} /> Imprimir
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
